"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.498 9.48c-.94 3.07-3.05 5.25-6.28 6.48-.06.02-.13.04-.2.04h-.03c-.07 0-.13-.01-.2-.04-9.37-3.56-6.32-14.12-6.29-14.22.03-.1.09-.19.16-.26C3.168.15 6.818.04 8.028 0h.02c.37 0 4.64.06 6.31 1.54l.29.26-1.1.5-.12-.08c-1.14-.77-3.92-1.08-5.41-1.09-1.44 0-4.35.23-5.51 1.09-.15.58-.63 2.73-.33 5.12.46 3.63 2.41 6.16 5.81 7.52 6.5-2.59 6.15-8.98 5.69-11.62l1.09-.28c.28 1.61.46 4.09-.29 6.53l.02-.01ZM5.128 7.9l-.58.81 2.45 1.75a.507.507 0 0 0 .69-.11l3.9-5.23-.8-.6-3.6 4.84-2.05-1.47-.01.01Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.674 14.198c-1.41 4.628-4.597 7.912-9.479 9.764a.606.606 0 0 1-.202.038h-.045a.643.643 0 0 1-.203-.038c-14.143-5.384-9.539-21.335-9.494-21.5a.65.65 0 0 1 .165-.263C4.651.212 10.193.055 12.016.002c1.102-.03 7.214.24 9.523 2.287l.105.098-1.14.517-.045-.03c-1.822-1.237-6.059-1.71-8.466-1.732h-.053c-.262 0-6.434.022-8.669 1.8-.195.727-1.02 4.192-.532 8.077.72 5.73 3.817 9.711 9.216 11.826 10.297-4.034 9.742-14.076 9.03-18.208l1.087-.375.015.097c.345 2.003.75 5.94-.443 9.84h.03ZM7.006 11.806l-.653.915 4.102 2.932c.098.068.21.105.33.105a.544.544 0 0 0 .45-.225l6.517-8.751-.9-.675-6.194 8.309-3.66-2.617.008.007Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    d: "M28.9 18.931c-1.88 6.17-6.13 10.55-12.64 13.019-.09.03-.17.05-.27.05h-.06c-.09 0-.18-.02-.27-.05C-3.198 24.77 2.941 3.502 3.001 3.282c.04-.13.12-.25.22-.35 2.98-2.65 10.37-2.86 12.8-2.93 1.47-.04 9.619.32 12.698 3.05l.14.13-1.52.69-.06-.04c-2.43-1.65-8.079-2.28-11.289-2.31h-.07c-.35 0-8.579.03-11.559 2.4-.26.97-1.36 5.59-.71 10.77.96 7.639 5.09 12.948 12.29 15.768 13.728-5.38 12.988-18.768 12.038-24.278l1.45-.5.02.13c.46 2.67 1 7.92-.59 13.12h.04Zm-19.56-3.19-.869 1.22 5.47 3.91c.13.09.28.14.44.14.23 0 .46-.1.6-.3L23.67 9.042l-1.2-.9-8.26 11.08-4.88-3.49.01.01Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    d: "M43.283 28.374c-2.827 9.27-9.217 15.846-18.989 19.566a.998.998 0 0 1-.337.06h-.09c-.113 0-.225-.023-.338-.06C-4.796 37.163 4.406 5.155 4.503 4.833a.987.987 0 0 1 .278-.435C9.093.573 19.66.131 24.03.003c1.433-.045 14.272.315 19.072 4.567l-1.935.878C37.306 2.83 28.33 1.96 24.002 1.93h-.113c-.877 0-13.184.082-17.646 3.697-.382 1.425-2.092 8.467-1.095 16.416C6.611 33.7 12.925 41.775 23.912 46.058 44.858 37.898 43.755 17.522 42.3 9.115l1.86-.487c.84 4.86 1.372 12.374-.878 19.738v.008Zm-30.17-3.9-1.088 1.523 8.79 6.284c.165.12.352.173.547.173.285 0 .57-.128.75-.375l13.964-18.742-1.5-1.117-13.409 18.006-8.04-5.752h-.014Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    d: "M57.71 37.832C53.94 50.19 45.423 58.96 32.393 63.92c-.14.05-.29.08-.45.08h-.12c-.15 0-.3-.03-.45-.08C-6.395 49.551 5.874 6.874 6.005 6.444c.07-.22.2-.43.37-.58 5.75-5.1 19.839-5.69 25.668-5.86 1.91-.06 19.03.42 25.429 6.09l-2.58 1.17c-5.15-3.49-17.119-4.65-22.889-4.69h-.151c-1.17 0-17.578.11-23.528 4.93-.51 1.9-2.79 11.29-1.46 21.888 1.95 15.54 10.37 26.309 25.018 32.018C59.81 50.53 58.341 23.363 56.401 12.154l2.48-.65c1.12 6.48 1.83 16.498-1.17 26.318v.01Zm-40.227-5.2-1.45 2.03 11.72 8.38c.22.16.47.23.73.23.38 0 .76-.17 1-.5L48.1 17.783l-2-1.49-17.878 24.009-10.72-7.67h-.02Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconCoverageCheck = function IconCoverageCheck(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Coverage Check' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "CoverageCheck"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconCoverageCheck.sizes = [16, 24, 32, 48, 64];
IconCoverageCheck.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconCoverageCheck;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/coverage-options/CoverageCheck.js
// module id = 1991
// module chunks = 0